import React from "react";
import "../../App.css";
import { Link } from "react-router-dom";

import RegistrationHeader from "../../components/registration/RegistrationHeader";
import PersonalInfoSection from "../../components/registration/PersonalInfoSection";
import ContactInfoSection from "../../components/registration/ContactInfoSection";
import InvitationCodeSection from "../../components/registration/InvitationCodeSection";
import RegistrationSummaryCard from "../../components/registration/RegistrationSummaryCard";

import useRegistrationForm from "../../hooks/useRegistrationForm";
import { useLanguage } from "../../context/LanguageContext";

function Registration() {
  const { language } = useLanguage();

  const {
    USA_MODE,
    fullName,
    setFullName,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    dni,
    setDni,
    handleDniBlur,
    email,
    setEmail,
    emailError,
    phone,
    setPhone,
    position,
    setPosition,
    region,
    setRegion,
    sector,
    setSector,
    employees,
    setEmployees,
    invitationCode,
    formErrors,
    invitationError,
    invitationSuccess,
    dniStatusError,
    isValidatingDni,
    isValidatingEmail,
    isValidatingCode,
    publicConfig,
    publicConfigError,
    isLoadingPublicConfig,
    currency,
    finalPrice,
    company,
    companyOptions,
    businessGroup,
    setBusinessGroup,
    mainRole,
    setMainRole,
    mainRoleOther,
    setMainRoleOther,
    mainInterest,
    setMainInterest,
    mainInterestOther,
    setMainInterestOther,
    eventSource,
    setEventSource,
    eventSourceOther,
    setEventSourceOther,
    paisesRegiones,
    sectorCompany,
    setStoredValue,
    handleCompanyChange,
    createCompany,
    handleInvitationCodeChange,
    btnNext,
    IS_FREE,
  } = useRegistrationForm(language);

  return (
    <div className="container">


      <RegistrationHeader language={language} />
      <form>
        <PersonalInfoSection
          language={language}
          USA_MODE={USA_MODE}
          fullName={fullName}
          setFullName={setFullName}
          firstName={firstName}
          setFirstName={setFirstName}
          lastName={lastName}
          setLastName={setLastName}
          dni={dni}
          setDni={setDni}
          handleDniBlur={handleDniBlur}
          email={email}
          setEmail={setEmail}
          setStoredValue={setStoredValue}
          formErrors={formErrors}
          emailError={emailError}
          dniStatusError={dniStatusError}
        />

        <ContactInfoSection
          language={language}
          USA_MODE={USA_MODE}
          phone={phone}
          setPhone={setPhone}
          position={position}
          setPosition={setPosition}
          region={region}
          setRegion={setRegion}
          sector={sector}
          setSector={setSector}
          employees={employees}
          setEmployees={setEmployees}
          setStoredValue={setStoredValue}
          formErrors={formErrors}
          paisesRegiones={paisesRegiones}
          sectorCompany={sectorCompany[language] || []}
          company={company}
          companyOptions={companyOptions}
          handleCompanyChange={handleCompanyChange}
          createCompany={createCompany}
          businessGroup={businessGroup}
          setBusinessGroup={setBusinessGroup}
          mainRole={mainRole}
          setMainRole={setMainRole}
          mainRoleOther={mainRoleOther}
          setMainRoleOther={setMainRoleOther}
          mainInterest={mainInterest}
          setMainInterest={setMainInterest}
          mainInterestOther={mainInterestOther}
          setMainInterestOther={setMainInterestOther}
          eventSource={eventSource}
          setEventSource={setEventSource}
          eventSourceOther={eventSourceOther}
          setEventSourceOther={setEventSourceOther}
        />

        <InvitationCodeSection
          language={language}
          IS_FREE={IS_FREE}
          invitationCode={invitationCode}
          handleInvitationCodeChange={handleInvitationCodeChange}
          invitationError={invitationError}
          invitationSuccess={invitationSuccess}
        />

        <div>
          <p className="legal">
            {language === "EN" ? "*Required fields" : "*Campos requeridos"}
          </p>

          <p className="legal">
            {language === "EN"
              ? "By submitting this form, you agree to our "
              : "Al enviar este formulario, aceptás nuestra "}
            <Link to="/privacy" target="_blank">
              {language === "EN" ? "Privacy Policy." : "Política de Privacidad."}
            </Link>
          </p>
        </div>

        <RegistrationSummaryCard
          language={language}
          IS_FREE={IS_FREE}
          finalPrice={finalPrice}
          currency={currency}
          btnNext={btnNext}
          isValidatingDni={isValidatingDni}
          isValidatingEmail={isValidatingEmail}
          dniStatusError={dniStatusError}
          emailError={emailError}
          isValidatingCode={isValidatingCode}
          invitationCode={invitationCode}
          publicConfig={publicConfig}
          publicConfigError={publicConfigError}
          isLoadingPublicConfig={isLoadingPublicConfig}
        />

        <h4 className="footerCopyright">
          {language === "EN"
            ? "Design, code, words, and hard work by "
            : "Design, code, words, and hard work by "}
          <Link to="https://wcm.media" target="blank">
            Wildcat Media.
          </Link>
        </h4>
      </form>
    </div>
  );
}

export default Registration;

